<app-contrast-provider>
  <ion-app>
    <ion-router-outlet></ion-router-outlet>
  </ion-app>
</app-contrast-provider>
